import styled from "@emotion/styled";

export const CampaignBriefsBox = styled.div`
  width: 100%;
  text-align: left;
  padding: 20px;
`;
